export const GET_RESERVATION_CONFIRMATION = 'GET_RESERVATION_CONFIRMATION_URL'
export const GET_RESERVATION_CONFIRMATION_RESPONSE = 'GET_RESERVATION_CONFIRMATION_URL_RESPONSE'
